import { SelectionOption } from '@app/shared/interfaces/selection-option';

export function getInvoiceDeliveryStatusChipClass(status: SelectionOption): string | null {
  switch (status.key) {
    case 'ON_THE_WAY':
      return 'blue';
    case 'DELIVERED':
      return 'green';
  }
  return '';
}

export function getOrderPrimaryChipClass(status: SelectionOption): string {
  switch (status.key) {
    case 'ORDER_IN_PROGRESS':
    case 'PO_IN_PROCESSING':
      return 'blue';
    case 'ORDER_FULFILLED':
      return 'light-green';
    case 'PO_ACCEPTED':
      return 'green';
  }
  return '';
}

export function getOrderSecondaryChipClass(status: SelectionOption): string {
  switch (status.key) {
    case 'QUOTE_VALIDITY_EXPIRED':
    case 'EXPIRED':
    case 'PAYMENT_OVERDUE':
      return 'dark-orange';
    case 'OPEN':
      return 'gray';
    case 'PAYMENT_DUE_SOON':
    case 'PAYMENT_PENDING':
    case 'IN_PROGRESS':
      return 'blue';
    case 'PARTIALLY_FULFILLED':
    case 'PAYMENT_RECEIVED':
      return 'green';
  }
  return '';
}
